module.exports = __webpack_public_path__ + "img/grid_blue.992aef92.png";